// extracted by mini-css-extract-plugin
export default {"morePeriods":"more_periods-module___morePeriods___ae3a04ae","ellipsis":"more_periods-module___ellipsis___fa3d3a53"};